module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#eee",
      "height": "100%"
    }
  }, [(_vm.definition.type == 'pd') ? _c('div', {
    staticClass: "progress-control padded",
    class: _vm.controlClass,
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    }
  }, [_c('div', {}, [_c('v-icon', {
    staticStyle: {
      "font-size": "45px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('div', {
    staticClass: "no-wrap",
    staticStyle: {
      "text-align": "center",
      "flex-grow": "1"
    }
  }, [_vm._v(_vm._s(_vm.dateInWords || 'Waiting'))])]) : _vm._e(), _vm._v(" "), (_vm.definition.type == 'pc') ? _c('div', {
    staticClass: "progress-control contact",
    class: _vm.controlClass,
    staticStyle: {
      "display": "flex",
      "height": "100%",
      "align-items": "center"
    }
  }, [_c('ImageGroup', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px",
      "flex-basis": "70px"
    },
    attrs: {
      "images": _vm.clientImages
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-wrap",
    staticStyle: {
      "font-size": "16px",
      "padding": "15px"
    }
  }, [_vm._v(_vm._s(_vm.clientNames || ' '))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef8409c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/ChartControl.vue
// module id = 2667
// module chunks = 1